// extracted by mini-css-extract-plugin
export var dots = "Dots-module--dots--2O8iT";
export var dots4 = "Dots-module--dots4--LUAn-";